import mixpanel from "mixpanel-browser";

// Initialize Mixpanel with your project token
mixpanel.init("e71f829d27aa19a68213d6c1fb24a487", {
  debug: process.env.NODE_ENV === "development",
  track_pageview: true,
  persistence: "localStorage",
});

// Utility functions for tracking
const Mixpanel = {
  identify: (id) => {
    mixpanel.identify(id);
  },
  alias: (id) => {
    mixpanel.alias(id);
  },
  track: (name, props) => {
    mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      mixpanel.people.set(props);
    },
  },
  // Page tracking events
  trackPageView: (pageName, additionalProps = {}) => {
    mixpanel.track("Page View", {
      page: pageName,
      ...additionalProps,
    });
  },
  // Planned events for your portfolio
  trackHome: (additionalProps = {}) => {
    mixpanel.track("Home Page Viewed", {
      page: "home",
      section: "portfolio",
      ...additionalProps,
    });
  },
  trackContact: (additionalProps = {}) => {
    mixpanel.track("Contact Page Viewed", {
      page: "contact",
      section: "portfolio",
      ...additionalProps,
    });
  },
  trackAviation: (additionalProps = {}) => {
    mixpanel.track("Aviation Page Viewed", {
      page: "aviation",
      section: "portfolio",
      ...additionalProps,
    });
  },
  trackProjects: (additionalProps = {}) => {
    mixpanel.track("Projects Page Viewed", {
      page: "projects",
      section: "portfolio",
      ...additionalProps,
    });
  },
  trackExperience: (additionalProps = {}) => {
    mixpanel.track("Experience Page Viewed", {
      page: "experience",
      section: "portfolio",
      ...additionalProps,
    });
  },
  // Additional interaction events
  trackProjectClick: (projectName, additionalProps = {}) => {
    mixpanel.track("Project Clicked", {
      project_name: projectName,
      action: "click",
      ...additionalProps,
    });
  },
  trackContactForm: (formType, additionalProps = {}) => {
    mixpanel.track("Contact Form Interaction", {
      form_type: formType,
      action: "form_interaction",
      ...additionalProps,
    });
  },
  trackNavigation: (fromPage, toPage, additionalProps = {}) => {
    mixpanel.track("Navigation", {
      from_page: fromPage,
      to_page: toPage,
      action: "navigation",
      ...additionalProps,
    });
  },
  // Contact-specific tracking methods
  trackEmailClick: (additionalProps = {}) => {
    mixpanel.track("Email BTN Click", {
      platform: "email",
      contact_method: "email",
      action: "contact_click",
      ...additionalProps,
    });
  },
  trackGithubClick: (additionalProps = {}) => {
    mixpanel.track("Github BTN Click", {
      platform: "github",
      contact_method: "github",
      action: "social_click",
      ...additionalProps,
    });
  },
  trackLinkedInClick: (additionalProps = {}) => {
    mixpanel.track("LinkedIn BTN Click", {
      platform: "linkedin",
      contact_method: "linkedin",
      action: "social_click",
      ...additionalProps,
    });
  },
  trackXClick: (additionalProps = {}) => {
    mixpanel.track("X BTN Click", {
      platform: "x",
      contact_method: "x",
      action: "social_click",
      ...additionalProps,
    });
  },
};

export default Mixpanel;
